import React, { MouseEventHandler } from 'react';

import { Tooltip, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { NavLink } from 'react-router-dom';

import { ReactComponent as Pointer } from 'assets/icons/general/pointer.svg';
import { useUserLogContext } from 'context/UserLogContext/UserLogContext';
import useLayoutStore from 'storages/layout';

import useStyles from './MenuLink.styles';

export type DisabledReason = 'under_construction' | 'premium';

export type MenuLinkIcon = React.FunctionComponent<{ className?: string }> | string;

export type MenuLinkType = {
  label: string;
  to: string;
  icon: MenuLinkIcon;
  disabled?: DisabledReason;
  iconWidth?: number;
  showIndicator?: boolean;
};

type Props = MenuLinkType;

const resolveTooltip = (disabledReason?: DisabledReason): { title: string; tooltipClassName?: string; arrowClassName?: string } => {
  switch (disabledReason) {
    case 'premium':
      return { title: '⭐ Premium', tooltipClassName: 'MenuTooltip_premium', arrowClassName: 'MenuTooltipArrow_premium' };
    case 'under_construction':
      return {
        title: 'Pracujemy nad tym',
        tooltipClassName: 'MenuTooltip_underConstruction',
        arrowClassName: 'MenuTooltipArrow_underConstruction',
      };
    default:
      return { title: '' };
  }
};

const MenuLink: React.FC<Props> = ({ to, label, icon, disabled, iconWidth, showIndicator }) => {
  const { logEvent } = useUserLogContext();
  const { toggleIsMenuVisible } = useLayoutStore();
  const onLinkClick: MouseEventHandler<HTMLAnchorElement> = () => {
    logEvent('hamburger-click', { button: label });
    toggleIsMenuVisible();
  };

  const tooltip = resolveTooltip(disabled);
  const classes = useStyles({ iconWidth });
  const iconElement =
    typeof icon === 'string' ? (
      <img alt='' className={classes.iconImage} src={icon} />
    ) : (
      React.createElement(icon, { className: classes.icon })
    );
  const row = (
    <>
      {iconElement}
      <div className={classes.labelWrapper}>
        <Typography>{label}</Typography>
        {disabled === 'premium' && <Typography className={classes.additionalTextBadge}>{tooltip.title}</Typography>}
      </div>
    </>
  );

  if (disabled === 'under_construction') {
    return null;
  }

  return (
    // <Tooltip placement='left' title={tooltip.title} arrow classes={{ tooltip: tooltip.tooltipClassName, arrow: tooltip.arrowClassName }}>
    <div className={classes.wrapper}>
      {disabled ? (
        <div aria-disabled className={clsx(classes.root, classes.disabled)} role='presentation'>
          {row}
        </div>
      ) : (
        <NavLink end className={classes.root} onClick={onLinkClick} to={to}>
          {row}
        </NavLink>
      )}
      {showIndicator && <Pointer className={classes.pointer} />}
    </div>
    // </Tooltip>
  );
};

export default MenuLink;
